/**
 * The XYRA wordmark — the brand's actual logo file (four rounded,
 * drop-shadowed tiles spelling the name), served from /public. Replaces the
 * old Meridian compass mark. Since the logo already spells out the name,
 * call sites show it alone (no separate "XYRA" text line needed alongside
 * it, unlike the old icon+text pairing).
 *
 * `compact` swaps in a single-tile "X" SVG monogram for collapsed-rail slots
 * too narrow for the full wordmark's image aspect ratio (the source file
 * isn't pre-cropped, so a slice-of-image approach would clip awkwardly).
 */
export function XyraMark({ className = 'h-9 w-auto', compact = false }: { className?: string; compact?: boolean }) {
  if (compact) {
    return (
      <svg className={className} viewBox="0 0 44 44" fill="none" role="img" aria-label="XYRA">
        <rect x={4} y={4} width={40} height={40} rx={10} fill="#2F5FB0" />
        <rect x={0} y={0} width={40} height={40} rx={10} fill="#4285F4" />
        <text
          x={20}
          y={20}
          textAnchor="middle"
          dominantBaseline="central"
          fill="#FFFFFF"
          fontSize={21}
          fontWeight={800}
          fontFamily="'Plus Jakarta Sans', Inter, sans-serif"
        >
          X
        </text>
      </svg>
    );
  }
  return <img src="/xyra.webp" alt="XYRA" className={className} style={{ objectFit: 'contain' }} />;
}
